import React, { useState, useEffect } from "react";
import { useAuth } from "../../Utility/AuthProvider";
import APICall from "../../Utility/APICall";
import { paths } from "../../Utility/Constants";
import { IoIosCloseCircleOutline } from "react-icons/io";
import CustomImage, { IMAGE_TYPES } from "../../Utility/CustomImage";
import { useUnitDetails } from "../Properties/UnitDetailsContext";

const CustomModalEditUnit = ({
  isOpen,
  onClose,
  unitDetails,
  buildings,
  onUpdate,
}) => {
  const { jwt } = useAuth();
  const { fetchUnitDetails } = useUnitDetails();
  const [unitName, setUnitName] = useState("");
  const [selectedBuilding, setSelectedBuilding] = useState("");
  const [address, setAddress] = useState("");
  const [buildingName, setBuildingName] = useState("");
  const [unitArea, setUnitArea] = useState("");
  const [furnishingStatus, setFurnishingStatus] = useState("furnished");
  const [bhk, setBhk] = useState("");
  const [amenities, setAmenities] = useState([]);
  const [newAmenity, setNewAmenity] = useState("");
  const [allAmenities, setAllAmenities] = useState([
    "WiFi",
    "CCTV",
    "Television",
    "Parking",
    "Refrigerator",
    "Laundry",
    "Security",
    "Inverter",
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [noOfBathrooms, setNoOfBathrooms] = useState(1);
  const [noOfBalcony, setNoOfBalcony] = useState(1);
  const [files, setFiles] = useState([]); // State for new files
  const [oldMedia, setOldMedia] = useState([]); // State for old media

  useEffect(() => {
    if (unitDetails) {
      setUnitName(unitDetails.unit.unit_name || "");
      setSelectedBuilding(unitDetails.unit.building_id || "");
      setUnitArea(unitDetails.unit.unit_area || "");
      setFurnishingStatus(unitDetails.unit.furnishing_status || "furnished");
      setBhk(unitDetails.unit.bhk || "");
      setAmenities(
        unitDetails.unit.amenities ? unitDetails.unit.amenities.split(",") : []
      );
      setOldMedia(unitDetails.unit.media || []); // Store old media
    }
  }, [unitDetails]);
  // Update buildingName when selectedBuilding changes
  useEffect(() => {
    if (selectedBuilding && buildings) {
      const selectedBuildingData = buildings.find(
        (building) => building.entity_id === selectedBuilding
      );
      setBuildingName(
        selectedBuildingData ? selectedBuildingData.building_name : ""
      );
      setAddress(selectedBuildingData ? selectedBuildingData.address : "");
    }
  }, [selectedBuilding, buildings]);

  console.log("selectedBuilding--", selectedBuilding);
  console.log("selected building Name --", buildingName);

  const handleAddAmenity = () => {
    if (newAmenity && !amenities.includes(newAmenity)) {
      setAmenities([...amenities, newAmenity]);
      if (!allAmenities.includes(newAmenity)) {
        setAllAmenities([...allAmenities, newAmenity]);
      }
      setNewAmenity("");
    }
  };

  const handleUpdateUnit = async () => {
    const media = files.map((item) => {
      return {
        name: item.name,
        location: `units/${unitDetails.unit.entity_id}/${item.name}`,
        type: item.type,
        height: item.height,
        width: item.width,
        size: item.size,
        description: item.description,
      };
    });

    const body = {
      unit_id: unitDetails.unit.entity_id,
      building_id: selectedBuilding,
      building_name: buildingName,
      address: address,
      unit_name: unitName,
      unit_area: unitArea,
      furnishing_status: furnishingStatus,
      bhk: bhk,
      no_of_bathrooms: noOfBathrooms,
      no_of_balcony: noOfBalcony,
      amenities: amenities,
      media:
        media.length > 0
          ? JSON.stringify(media)
          : oldMedia.length > 0
            ? JSON.stringify(oldMedia)
            : null,
    };

    console.log("🎃 update unit body -", body);

    try {
      setIsLoading(true);
      const res = await APICall("PUT", paths.unit.update, body, undefined, jwt);
      console.log("👺 update unit api call response -", res);

      if (res.status === "success") {
        await fetchUnitDetails(unitDetails.unit.entity_id); // Refresh unit details
        onUpdate();
        onClose();
      } else {
        console.error("Failed to update unit:", res.message);
      }
    } catch (error) {
      console.error("Error updating unit:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  const getInitials = (name) => {
    const nameParts = name.split(" ");
    return nameParts
      .map((part) => part.charAt(0))
      .join("")
      .toUpperCase();
  };

  const handleIncrement = (field) => {
    if (field === "balcony") {
      setNoOfBalcony(noOfBalcony + 1);
    } else if (field === "bathroom") {
      setNoOfBathrooms(noOfBathrooms + 1);
    }
  };

  const handleDecrement = (field) => {
    if (field === "balcony" && noOfBalcony > 0) {
      setNoOfBalcony(noOfBalcony - 1);
    } else if (field === "bathroom" && noOfBathrooms > 0) {
      setNoOfBathrooms(noOfBathrooms - 1);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-1/2 max-h-[90vh] overflow-y-auto relative">
        {/* <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
        >
          <IoIosCloseCircleOutline size={30} />
        </button> */}
        <h2 className="text-xl font-bold mb-4 text-center">Update Unit</h2>
        <form>
          <div className="flex justify-center items-center">
            <CustomImage
              location={
                unitDetails.unit.media && unitDetails.unit.media.length > 0
                  ? unitDetails.unit.media[0].location
                  : null // Pass null if no media
              }
              // jwt={jwt} // CustomImage uses useAuth() internally, so this might not be needed
              // if your CustomImage component is the one from our previous discussions.
              // If it still explicitly takes jwt, keep it.
              className="h-20 w-20 rounded-full"
              imageType={IMAGE_TYPES.FLAT} // This tells CustomImage to show a flat icon on fallback
              loaderSize={80}
              altText={`Image of ${unitName}`} // Good practice for accessibility
            />
          </div>
          {/* <div className="flex justify-center items-center">
            {unitDetails.unit.media && unitDetails.unit.media.length > 0 ? (
              <CustomImage
                location={unitDetails.unit.media[0].location}
                jwt={jwt}
                className="h-20 w-20 rounded-full"
                imageType={IMAGE_TYPES.FLAT}
                loaderSize={80}
              />
            ) : (
              <div className="h-20 w-20 flex items-center justify-center rounded-full bg-gray-200">
                {getInitials(unitName)}
              </div>
            )}
          </div> */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Unit Name</label>
            <input
              type="text"
              value={unitName}
              onChange={(e) => setUnitName(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Building</label>
            <select
              value={selectedBuilding}
              onChange={(e) => setSelectedBuilding(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
            >
              <option value="">Select Building</option>
              {buildings.map((building) => (
                <option key={building.entity_id} value={building.entity_id}>
                  {building.building_name}, {building.address}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Unit Area</label>
            <input
              type="text"
              value={unitArea}
              onChange={(e) => setUnitArea(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              Furnishing Status
            </label>
            <select
              value={furnishingStatus}
              onChange={(e) => setFurnishingStatus(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
            >
              <option value="furnished">Furnished</option>
              <option value="semi-furnished">Semi-Furnished</option>
              <option value="non-furnished">Non-Furnished</option>
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">BHK</label>
            <input
              type="text"
              value={bhk}
              onChange={(e) => setBhk(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
            />
          </div>

          <div className="flex gap-8 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Balcony</label>
              <div className="flex items-center">
                <button
                  type="button"
                  onClick={() => handleDecrement("balcony")}
                  className="bg-gray-300 px-2 py-1 rounded mr-2"
                >
                  -
                </button>
                <p>{noOfBalcony}</p>
                <button
                  type="button"
                  onClick={() => handleIncrement("balcony")}
                  className="bg-gray-300 px-2 py-1 rounded ml-2"
                >
                  +
                </button>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Bathroom</label>
              <div className="flex items-center">
                <button
                  type="button"
                  onClick={() => handleDecrement("bathroom")}
                  className="bg-gray-300 px-2 py-1 rounded mr-2"
                >
                  -
                </button>
                <p>{noOfBathrooms}</p>
                <button
                  type="button"
                  onClick={() => handleIncrement("bathroom")}
                  className="bg-gray-300 px-2 py-1 rounded ml-2"
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Amenities</label>
            <div className="flex flex-wrap gap-2 mb-2">
              {allAmenities.map((amenity) => (
                <button
                  key={amenity}
                  type="button"
                  className={`px-3 py-1 border rounded-lg ${
                    amenities.includes(amenity)
                      ? "bg-blue-700 text-white"
                      : "bg-gray-200"
                  }`}
                  onClick={() => {
                    setAmenities((prev) =>
                      prev.includes(amenity)
                        ? prev.filter((item) => item !== amenity)
                        : [...prev, amenity]
                    );
                  }}
                >
                  {amenity}
                </button>
              ))}
            </div>
            <input
              type="text"
              value={newAmenity}
              onChange={(e) => setNewAmenity(e.target.value)}
              placeholder="Add new amenity"
              className="w-full p-2 border border-gray-300 rounded mb-2"
            />
            <button
              type="button"
              onClick={handleAddAmenity}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Add Amenity
            </button>
          </div>
          <div className="flex justify-end mt-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 text-black px-4 py-2 rounded mr-2"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleUpdateUnit}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              disabled={isLoading}
            >
              {isLoading ? "Updating..." : "Update Unit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomModalEditUnit;
